import { createSlice } from '@reduxjs/toolkit';

import { handleGetMedicationSettings } from './actions';
import { IMedicationSettingsState } from './slice.interface';

const initialState: IMedicationSettingsState = {
  data: null,
  isLoading: false,
  isReady: false,
  error: false,
};

export const medicationSettingsSlice = createSlice({
  name: 'medication-settings',
  initialState,
  reducers: {
    removeMedicationSettings: state => {
      state.data = null;
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetMedicationSettings.pending, (state: IMedicationSettingsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetMedicationSettings.rejected, (state: IMedicationSettingsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetMedicationSettings.fulfilled, (state: IMedicationSettingsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeMedicationSettings } = medicationSettingsSlice.actions;

export default medicationSettingsSlice.reducer;
